// @ts-nocheck
import React from 'react'
import Edit from '../../crud/edit/index-dup'
import fields from './edit-fields'
import menuItems from './menuItems'
import Spacer from '../../spacer'
import RaisedButton from 'material-ui/RaisedButton'
import { browserHistory } from 'react-router'
import IntakeAnswersEditor from './IntakeAnswersEditor'

const EditReservation = (props) => {
  const sessionReservationId = parseInt(props.params.sessionReservationId)

  return (
    <div>
      <Spacer />
      <Spacer />
      <RaisedButton
        label='Back'
        onClick={e => { handleBack(e) }}
      />
      <Spacer />
      <Edit
// @ts-ignore
        title='Edit Session Reservation'
        fields={fields}
        apiPath={`admin/session_reservations/${props.params.sessionReservationId}`}
        successRedirectPath={`/events/session-sales/${props.params.sessionSaleId}/reservations`}
        buildMenuItems={menuItems}
      />
      <IntakeAnswersEditor sessionReservationId={sessionReservationId} />
    </div>
  )
}
const handleBack = (e) => {
  e.preventDefault()
  browserHistory.goBack()
}

export default EditReservation
